import "url-polyfill";

import inject from "@ubisend/pulse-inject-iframe";
import "./../node_modules/@ubisend/pulse-inject-iframe/src/styles/iframe.css";

inject(process.env.REACT_APP_WIDGET_JS, process.env.REACT_APP_WIDGET_CSS);
